import { useNavigate } from 'react-router-dom'
import { BackArrowIcon } from './back-arrow-icon'

export { getDetailBackButtonFallback } from '../page-title/detail-route-fallbacks'

interface BackCircleButtonProps {
  fallbackPath?: string
  className?: string
}

export const BackCircleButton = ({
  fallbackPath,
  className = '',
}: BackCircleButtonProps) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (window.history.length > 1) {
      navigate(-1)
      return
    }

    if (fallbackPath) {
      navigate(fallbackPath)
    }
  }

  return (
    <button
      type="button"
      aria-label="Назад"
      className={`inline-flex h-11 w-11 items-center justify-center rounded-full border border-[#D9D9D9] bg-white shadow-sm transition hover:bg-[#F8F8F8] ${className}`}
      onClick={handleClick}
    >
      <BackArrowIcon size={24} />
    </button>
  )
}
